import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from "../../assets/img/yallafelsekka.svg";
import useSaasAccount from '../../hooks/useSaasAccount';

const Header = ({ setShowTrackOrder }) => {
    const { isOwner, logoUrl } = useSaasAccount()
    const [isOpen, setIsOpen] = useState(false);

    const logoLightSrc = isOwner ? logoImg : logoUrl

    const toggleMenu = (e) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    }

    const handleClick = () => {
        setIsOpen(false);
        setShowTrackOrder(true)
    }

    return (
        <header className="header_in clearfix">
            <div className="container">
                <div id="logo">
                    <NavLink to="/">
                        {logoLightSrc ? <img src={logoLightSrc} id='logo-icon' height="40" alt="YFS" /> : null}
                    </NavLink>
                </div>
                <div className="layer"></div>
                <a href="#0" className="open_close" onClick={toggleMenu}> <i className="icon_menu"></i><span>Menu</span> </a>
                <nav className={`main-menu ${isOpen ? 'show' : ''}`}>
                    <div id="header_menu">
                        <a href="#0" className="open_close" onClick={toggleMenu}> <i className="icon_close" style={{ color: "darkgray" }}></i><span>Menu</span> </a>
                        <NavLink to="/">
                            {logoLightSrc ? <img src={logoLightSrc} width="162" height="40" alt="YFS" /> : null}
                        </NavLink>
                    </div>
                    <ul id="nav-link">
                        <li><NavLink className={({ isActive }) => (isActive ? "active-link" : "")} to="/" onClick={handleClick}>Track Order</NavLink></li>
                    </ul>
                </nav>
            </div>
        </header >
    );
}

export default Header;
